import { useTranslation } from "react-i18next";

import { useCompany } from "#modules/company/view/useCompany";
import { OnboardingActivityTypeType } from "shared";

const ACTIVITY_TYPE_TRANSLATION_KEY: Record<
  OnboardingActivityTypeType,
  "sheet" | "boilermaking" | "machining"
> = {
  SHEET: "sheet",
  BOILERMAKING: "boilermaking",
  MACHINING: "machining",
};

export const useOnboardingActivityTypeLabel = () => {
  const { t } = useTranslation();
  const { company } = useCompany();

  return company?.onboardingActivityType
    ? t(
        `onboardingV2.activityType.options.${ACTIVITY_TYPE_TRANSLATION_KEY[company.onboardingActivityType]}.title`,
      ).toLowerCase()
    : "";
};
